export default __webpack_public_path__ + "static/media/08-jorge-valdano-b.2888b14f.png";